import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { PAGES as ROOT_PAGES } from '@utils/constants';
import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/mdi/state-machine';

const routes: RouteRecordRaw[] = [
	{
		path: '/workflow',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			isAllowed: ({ canAccessWorkflow }) => canAccessWorkflow || ROOT_PAGES.MODULES,
			documentTitle: 'Workflow',
			title: 'Workflow',
		},
	},
];

/** Not built here: motorway/mw-workflow-admin, loaded at runtime as a Module Federation remote (lib/remote.ts). */
export const WORKFLOW_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.HOME },
	title: 'Workflow',
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessWorkflow }) => canAccessWorkflow,
	routes,
};
